import './sprite'
import Zoom from './blocks/zoom'

import './vendors/transition';
import './vendors/collapse';
import './vendors/dropdown';
import './vendors/modal';
import './vendors/jquery.transform3d';
import 'jquery-mousewheel';

//$(() => (new Zoom()).render());

const advertising = [
  {
    "id": 2,
    "text": "Arena",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/92203.phtml",
    "group": 5,
    "world": "Havas",
    "russian": "АДВ",
    "office": "Havas Village Russia"
  },
  {
    "id": 3,
    "text": "Havas Media",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/101320.phtml",
    "group": 2,
    "world": "Havas",
    "russian": "АДВ",
    "office": "Havas Village Russia"
  },
  {
    "id": 4,
    "text": "AdLabs",
    "link": "https://adindex.ru/catalogue/reclama_services/group_of_companies/109376.phtml",
    "group": 4,
    "world": "",
    "russian": "АДВ",
    "office": ""
  },
  {
    "id": 5,
    "text": "Havas Creative Group Russia",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/281996.phtml",
    "group": 1,
    "world": "Havas",
    "russian": "АДВ",
    "office": "Havas Village Russia"
  },
  {
    "id": 6,
    "text": "Havas Life Moscow",
    "link": "https://adindex.ru/catalogue/digital/fullservice/281999.phtml",
    "group": 1,
    "world": "Havas",
    "russian": "АДВ",
    "office": "Havas Village Russia"
  },
  {
    "id": 7,
    "text": "Arnold Moscow",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/282000.phtml",
    "group": 1,
    "world": "Havas",
    "russian": "АДВ",
    "office": "Havas Village Russia"
  },
  {
    "id": 8,
    "text": "Havas Moscow",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/73870.phtml",
    "group": 1,
    "world": "Havas",
    "russian": "АДВ",
    "office": "Havas Village Russia"
  },
  {
    "id": 9,
    "text": "Havas Social Newsroom",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/282001.phtml",
    "group": 3,
    "world": "Havas",
    "russian": "АДВ",
    "office": "Havas Village Russia"
  },
  {
    "id": 10,
    "text": "Maxima",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/92598.phtml",
    "group": 2,
    "world": "",
    "russian": "АДВ",
    "office": ""
  },
  {
    "id": 11,
    "text": "Initiative",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/76768.phtml",
    "group": 2,
    "world": "IPG Mediabrands",
    "russian": "АДВ",
    "office": "IPG Mediabrands"
  },
  {
    "id": 12,
    "text": "M-Liner",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/73653.phtml",
    "group": 2,
    "world": "IPG Mediabrands",
    "russian": "АДВ",
    "office": "IPG Mediabrands"
  },
  {
    "id": 13,
    "text": "UM",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/134913.phtml",
    "group": 2,
    "world": "IPG Mediabrands",
    "russian": "АДВ",
    "office": "IPG Mediabrands"
  },
  {
    "id": 14,
    "text": "Reprise",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/282003.phtml",
    "group": 4,
    "world": "IPG Mediabrands",
    "russian": "АДВ",
    "office": "IPG Mediabrands"
  },
  {
    "id": 15,
    "text": "FCB Moscow",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/ttl/122177.phtml",
    "group": 1,
    "world": "IPG",
    "russian": "АДВ",
    "office": "IPG"
  },
  {
    "id": 16,
    "text": "McCann Moscow",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/101328.phtml",
    "group": 1,
    "world": "IPG",
    "russian": "АДВ",
    "office": "IPG"
  },
  {
    "id": 17,
    "text": "MullenLOWE Moscow",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/77010.phtml",
    "group": 1,
    "world": "IPG",
    "russian": "АДВ",
    "office": "IPG"
  },
  {
    "id": 18,
    "text": "Impacto",
    "link": "https://adindex.ru/catalogue/reclama_services/trade_marketing/74556.phtml",
    "group": 3,
    "world": "IPG",
    "russian": "АДВ Экспириенс",
    "office": "IPG"
  },
  {
    "id": 19,
    "text": "Momentum",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/btl/122118.phtml",
    "group": 3,
    "world": "IPG",
    "russian": "АДВ Экспириенс",
    "office": "IPG"
  },
  {
    "id": 20,
    "text": "Octagon",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/282004.phtml",
    "group": 3,
    "world": "IPG",
    "russian": "АДВ Экспириенс",
    "office": "IPG"
  },
  {
    "id": 21,
    "text": "PRP — A Weber Shandwick Affiliate Company",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/pr/110522.phtml",
    "group": 3,
    "world": "IPG",
    "russian": "АДВ Экспириенс",
    "office": "IPG"
  },
  {
    "id": 22,
    "text": "TMA-Draft",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/btl/81986.phtml",
    "group": 3,
    "world": "IPG",
    "russian": "АДВ Экспириенс",
    "office": "IPG"
  },
  {
    "id": 23,
    "text": "Havas Sports & Entertainment",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/282005.phtml",
    "group": 3,
    "world": "",
    "russian": "АДВ Экспириенс",
    "office": ""
  },
  {
    "id": 24,
    "text": "Carat",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/73707.phtml",
    "group": 2,
    "world": "Dentsu Aegis Network",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 25,
    "text": "Vizeum",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/73861.phtml",
    "group": 2,
    "world": "Dentsu Aegis Network",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 26,
    "text": "dentsu X",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/100789.phtml",
    "group": 2,
    "world": "Dentsu Aegis Network",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 27,
    "text": "People & Screens",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/282005.phtml",
    "group": 2,
    "world": "Dentsu Aegis Network",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 28,
    "text": "Amplifi",
    "link": "https://adindex.ru/catalogue/digital/282007.phtml",
    "group": 3,
    "world": "Dentsu Aegis Network",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 29,
    "text": "The Story Lab",
    "link": "https://adindex.ru/catalogue/reclama_services/272726.phtml",
    "group": 3,
    "world": "Dentsu Aegis Network",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 30,
    "text": "Aaron Lloyd",
    "link": "https://adindex.ru/catalogue/digital/mobile_marketing/282008.phtml",
    "group": 3,
    "world": "Dentsu Aegis Network",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 31,
    "text": "Posterscope Russia",
    "link": "https://adindex.ru/catalogue/media/outdoor_advertising/91350.phtml",
    "group": 3,
    "world": "Dentsu Aegis Network",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 32,
    "text": "Isobar Moscow",
    "link": "https://adindex.ru/catalogue/digital/web_design/278069.phtml",
    "group": 3,
    "world": "Dentsu Aegis Network",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 33,
    "text": "Traffic Isobar",
    "link": "https://adindex.ru/catalogue/digital/digital_creative/78219.phtml",
    "group": 4,
    "world": "Dentsu Aegis Network",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 34,
    "text": "iProspect",
    "link": "https://adindex.ru/catalogue/digital/seo/105220.phtml",
    "group": 4,
    "world": "Dentsu Aegis Network",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 35,
    "text": "Amnet",
    "link": "https://adindex.ru/catalogue/digital/fullservice/110287.phtml",
    "group": 4,
    "world": "Dentsu Aegis Network",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 36,
    "text": "adActum",
    "link": "https://adindex.ru/catalogue/media/media_holdings/122163.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 37,
    "text": "Media Mind",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/direct_marketing/282009.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 38,
    "text": "All.Agency",
    "link": "https://adindex.ru/catalogue/digital/digital_creative/282010.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 39,
    "text": "B.Bright",
    "link": "https://adindex.ru/catalogue/media/outdoor_advertising/282011.phtml",
    "group": 3,
    "world": "",
    "russian": "",
    "office": "Dentsu Aegis Network Russia"
  },
  {
    "id": 40,
    "text": "Maximize",
    "link": "https://adindex.ru/catalogue/digital/mobile_marketing/282012.phtml",
    "group": 2,
    "world": "WPP",
    "russian": "",
    "office": "GroupM"
  },
  {
    "id": 41,
    "text": "MediaCom",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/77158.phtml",
    "group": 2,
    "world": "WPP",
    "russian": "",
    "office": "GroupM"
  },
  {
    "id": 42,
    "text": "Mindshare",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/77199.phtml",
    "group": 2,
    "world": "WPP",
    "russian": "",
    "office": "GroupM"
  },
  {
    "id": 43,
    "text": "Wavemaker",
    "link": "https://adindex.ru/catalogue/digital/mobile_marketing/282013.phtml",
    "group": 2,
    "world": "WPP",
    "russian": "",
    "office": "GroupM"
  },
  {
    "id": 44,
    "text": "Promo Interactive",
    "link": "https://adindex.ru/catalogue/digital/web_design/77681.phtml",
    "group": 4,
    "world": "WPP",
    "russian": "",
    "office": "Ogilvy Group Russia"
  },
  {
    "id": 45,
    "text": "VMLY&R",
    "link": "https://adindex.ru/catalogue/digital/mobile_marketing/282013.phtml",
    "group": 3,
    "world": "WPP",
    "russian": "",
    "office": ""
  },
  {
    "id": 46,
    "text": "Fitch",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/branding/76461.phtml",
    "group": 3,
    "world": "WPP",
    "russian": "",
    "office": ""
  },
  {
    "id": 47,
    "text": "GEOMETRY",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/111319.phtml",
    "group": 1,
    "world": "WPP",
    "russian": "",
    "office": ""
  },
  {
    "id": 48,
    "text": "Grey",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/70785.phtml",
    "group": 5,
    "world": "WPP",
    "russian": "",
    "office": ""
  },
  {
    "id": 49,
    "text": "Wunderman Thompson Moscow",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/76882.phtml",
    "group": 3,
    "world": "WPP",
    "russian": "",
    "office": ""
  },
  {
    "id": 50,
    "text": "Millward Brown A/R/M/I-Marketing",
    "link": "https://adindex.ru/catalogue/researches/134227/122117.phtml",
    "group": 3,
    "world": "WPP",
    "russian": "",
    "office": ""
  },
  {
    "id": 51,
    "text": "PBN Hill+Knowlton Strategies",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/btl/122170.phtml",
    "group": 3,
    "world": "WPP",
    "russian": "",
    "office": ""
  },
  {
    "id": 52,
    "text": "Landor",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/branding/91005.phtml",
    "group": 3,
    "world": "WPP",
    "russian": "",
    "office": ""
  },
  {
    "id": 53,
    "text": "Kantar",
    "link": "https://adindex.ru/catalogue/digital/102586/282015.phtml",
    "group": 3,
    "world": "WPP",
    "russian": "",
    "office": ""
  },
  {
    "id": 54,
    "text": "Grape",
    "link": "https://adindex.ru/catalogue/digital/fullservice/76620.phtml",
    "group": 1,
    "world": "WPP",
    "russian": "Possible",
    "office": "Possible"
  },
  {
    "id": 55,
    "text": "Hungry Boys",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/94280.phtml",
    "group": 1,
    "world": "WPP",
    "russian": "Possible",
    "office": "Possible"
  },
  {
    "id": 56,
    "text": "Possible Moscow",
    "link": "https://adindex.ru/catalogue/digital/mobile_marketing/282016.phtml",
    "group": 1,
    "world": "WPP",
    "russian": "Possible",
    "office": "Possible"
  },
  {
    "id": 57,
    "text": "BBDO Branding",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/branding/92066.phtml",
    "group": 3,
    "world": "Omnicom",
    "russian": "BBDO Group",
    "office": ""
  },
  {
    "id": 58,
    "text": "BBDO Moscow",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/75865.phtml",
    "group": 1,
    "world": "Omnicom",
    "russian": "BBDO Group",
    "office": ""
  },
  {
    "id": 59,
    "text": "BOOTLEG",
    "link": "https://adindex.ru/catalogue/digital/media_selling/282017.phtml",
    "group": 1,
    "world": "Omnicom",
    "russian": "BBDO Group",
    "office": ""
  },
  {
    "id": 60,
    "text": "Contrapunto",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/110363.phtml",
    "group": 1,
    "world": "Omnicom",
    "russian": "BBDO Group",
    "office": ""
  },
  {
    "id": 61,
    "text": "Instinct",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/76783.phtml",
    "group": 1,
    "world": "Omnicom",
    "russian": "BBDO Group",
    "office": ""
  },
  {
    "id": 62,
    "text": "MORE",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/122161.phtml",
    "group": 1,
    "world": "Omnicom",
    "russian": "BBDO Group",
    "office": ""
  },
  {
    "id": 63,
    "text": "Proximity",
    "link": "https://adindex.ru/catalogue/digital/digital_creative/74602.phtml",
    "group": 1,
    "world": "Omnicom",
    "russian": "BBDO Group",
    "office": ""
  },
  {
    "id": 64,
    "text": "The Marketing Arm",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/event/274796.phtml",
    "group": 3,
    "world": "Omnicom",
    "russian": "BBDO Group",
    "office": ""
  },
  {
    "id": 65,
    "text": "Code Of Trade",
    "link": "https://adindex.ru/catalogue/digital/media_selling/110362.phtml",
    "group": 2,
    "world": "Omnicom",
    "russian": "",
    "office": "Media Direction Group"
  },
  {
    "id": 66,
    "text": "Media Wise",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/120203.phtml",
    "group": 2,
    "world": "Omnicom",
    "russian": "",
    "office": "Media Direction Group"
  },
  {
    "id": 67,
    "text": "OMD Media Direction",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/73767.phtml",
    "group": 2,
    "world": "Omnicom",
    "russian": "",
    "office": "Media Direction Group"
  },
  {
    "id": 68,
    "text": "PHD",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/73860.phtml",
    "group": 2,
    "world": "Omnicom",
    "russian": "",
    "office": "Media Direction Group"
  },
  {
    "id": 69,
    "text": "Proximity Media",
    "link": "https://adindex.ru/catalogue/digital/mobile_marketing/282019.phtml",
    "group": 2,
    "world": "Omnicom",
    "russian": "",
    "office": "Media Direction Group"
  },
  {
    "id": 70,
    "text": "BrandScience",
    "link": "https://adindex.ru/catalogue/researches/134227/110360.phtml",
    "group": 3,
    "world": "Omnicom",
    "russian": "",
    "office": "Media Direction Group"
  },
  {
    "id": 71,
    "text": "FUSE Media Direction Group",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/btl/110424.phtml",
    "group": 3,
    "world": "Omnicom",
    "russian": "",
    "office": "Media Direction Group"
  },
  {
    "id": 72,
    "text": "Media Direction Digital",
    "link": "https://adindex.ru/catalogue/reclama_services/group_of_companies/73769.phtml",
    "group": 4,
    "world": "Omnicom",
    "russian": "",
    "office": "Media Direction Group"
  },
  {
    "id": 73,
    "text": "Media Direction Programmatic",
    "link": "https://adindex.ru/catalogue/digital/mobile_marketing/282020.phtml",
    "group": 4,
    "world": "Omnicom",
    "russian": "",
    "office": "Media Direction Group"
  },
  {
    "id": 74,
    "text": "Media Direction Sport",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/ambient/282021.phtml",
    "group": 3,
    "world": "Omnicom",
    "russian": "",
    "office": "Media Direction Group"
  },
  {
    "id": 76,
    "text": "M2M",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/73755.phtml",
    "group": 3,
    "world": "Omnicom",
    "russian": "OMD OM Group",
    "office": "OMD OM Group"
  },
  {
    "id": 77,
    "text": "OMD AMS",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/73704.phtml",
    "group": 2,
    "world": "Omnicom",
    "russian": "OMD OM Group",
    "office": "OMD OM Group"
  },
  {
    "id": 78,
    "text": "OMD DaVinci",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/83960.phtml",
    "group": 3,
    "world": "Omnicom",
    "russian": "OMD OM Group",
    "office": "OMD OM Group"
  },
  {
    "id": 79,
    "text": "OMD Fuse",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/ambient/110502.phtml",
    "group": 3,
    "world": "Omnicom",
    "russian": "OMD OM Group",
    "office": "OMD OM Group"
  },
  {
     "id": 80,
     "text": "OMD Optimum Media",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/73770.phtml",
     "group": 2,
     "world": "Omnicom",
     "russian": "OMD OM Group",
     "office": "OMD OM Group"
   },
   {
     "id": 81,
     "text": "OMD Resolution",
     "link": "https://adindex.ru/catalogue/digital/mobile_marketing/82975.phtml",
     "group": 4,
     "world": "Omnicom",
     "russian": "OMD OM Group",
     "office": "OMD OM Group"
   },
   {
     "id": 83,
     "text": "Easy Media",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/95310.phtml",
     "group": 2,
     "world": "",
     "russian": "OMD OM Group",
     "office": "OMD OM Group"
   },
   {
     "id": 84,
     "text": "MediaPlan",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/73761.phtml",
     "group": 2,
     "world": "",
     "russian": "OMD OM Group",
     "office": "OMD OM Group"
   },
   {
     "id": 87,
     "text": "RMS",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/106146.phtml",
     "group": 3,
     "world": "",
     "russian": "OMD OM Group",
     "office": "OMD OM Group"
   },
   {
     "id": 88,
     "text": "Air",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/110349.phtml",
     "group": 2,
     "world": "",
     "russian": "OMD OM Group",
     "office": "Media Instinct Group"
   },
   {
     "id": 89,
     "text": "Horizon",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/110426.phtml",
     "group": 2,
     "world": "",
     "russian": "OMD OM Group",
     "office": "Media Instinct Group"
   },
   {
     "id": 90,
     "text": "Match",
     "link": "https://adindex.ru/catalogue/foundation/advertising-production/110470.phtml",
     "group": 3,
     "world": "",
     "russian": "OMD OM Group",
     "office": "Media Instinct Group"
   },
   {
     "id": 91,
     "text": "Media Pulse",
     "link": "https://adindex.ru/catalogue/digital/282024.phtml",
     "group": 2,
     "world": "",
     "russian": "OMD OM Group",
     "office": "Media Instinct Group"
   },
   {
     "id": 92,
     "text": "Media Trust",
     "link": "https://adindex.ru/catalogue/digital/97839/282025.phtml",
     "group": 2,
     "world": "",
     "russian": "OMD OM Group",
     "office": "Media Instinct Group"
   },
   {
     "id": 93,
     "text": "MediaInstinct",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/77129.phtml",
     "group": 2,
     "world": "",
     "russian": "OMD OM Group",
     "office": "Media Instinct Group"
   },
   {
     "id": 94,
     "text": "Media Instinct Digital",
     "link": "https://adindex.ru/catalogue/digital/web_design/282026.phtml",
     "group": 4,
     "world": "",
     "russian": "OMD OM Group",
     "office": "Media Instinct Group"
   },
   {
     "id": 95,
     "text": "DDB Russia",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/76189.phtml",
     "group": 1,
     "world": "Omnicom",
     "russian": "",
     "office": ""
   },
   {
     "id": 96,
     "text": "FleishmanHillard Vanguard",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/pr/122091.phtml",
     "group": 3,
     "world": "Omnicom",
     "russian": "",
     "office": ""
   },
   {
     "id": 97,
     "text": "Ketchum Maslov",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/pr/92690.phtml",
     "group": 3,
     "world": "Omnicom",
     "russian": "",
     "office": ""
   },
   {
     "id": 98,
     "text": "TBWA\\Moscow",
     "link": "https://adindex.ru/catalogue/reclama_services/group_of_companies/73639.phtml",
     "group": 1,
     "world": "Omnicom",
     "russian": "",
     "office": ""
   },
   {
     "id": 99,
     "text": "Arc Russia",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/122106.phtml",
     "group": 3,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 101,
     "text": "Digitas",
     "link": "https://adindex.ru/catalogue/digital/fullservice/105622.phtml",
     "group": 4,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 102,
     "text": "Graphit",
     "link": "https://adindex.ru/catalogue/digital/web_design/89238.phtml",
     "group": 3,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 103,
     "text": "Leo Burnett Moscow",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/76952.phtml",
     "group": 1,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 104,
     "text": "MSL",
     "link": "https://adindex.ru/catalogue/digital/digital_creative/282037.phtml",
     "group": 3,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 105,
     "text": "Performics",
     "link": "https://adindex.ru/catalogue/digital/web_design/282028.phtml",
     "group": 4,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 106,
     "text": "Prodigious",
     "link": "https://adindex.ru/catalogue/digital/fullservice/282029.phtml",
     "group": 3,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 107,
     "text": "Publicis Emil",
     "link": "https://adindex.ru/catalogue/digital/mobile_marketing/282030.phtml",
     "group": 1,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 108,
     "text": "Publicis ProHealth",
     "link": "https://adindex.ru/catalogue/digital/web_design/282033.phtml",
     "group": 1,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 109,
     "text": "Publicis Russia",
     "link": "https://adindex.ru/catalogue/media/media_holdings/282034.phtml",
     "group": 1,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 110,
     "text": "Saatchi&Saatchi Russia",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/77918.phtml",
     "group": 1,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 111,
     "text": "Spark Foundry",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/169441.phtml",
     "group": 2,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 112,
     "text": "Starcom",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/78079.phtml",
     "group": 2,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 113,
     "text": "Starlink",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/78081.phtml",
     "group": 2,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 114,
     "text": "Zenith",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/110686.phtml",
     "group": 2,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 115,
     "text": "Родная речь",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/81471.phtml",
     "group": 1,
     "world": "Publicis Groupe",
     "russian": "Publicis Groupe Russia",
     "office": ""
   },
   {
     "id": 117,
     "text": "Magma Rus",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/branding/110465.phtml",
     "group": 2,
     "world": "Serviceplan Group",
     "russian": "Serviceplan Group Rus",
     "office": "MediaPlus Group"
   },
   {
     "id": 118,
     "text": "Medialect",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/73760.phtml",
     "group": 2,
     "world": "Serviceplan Group",
     "russian": "Serviceplan Group Rus",
     "office": "MediaPlus Group"
   },
   {
     "id": 119,
     "text": "Mediaplus Digital",
     "link": "https://adindex.ru/catalogue/digital/fullservice/282038.phtml",
     "group": 4,
     "world": "Serviceplan Group",
     "russian": "Serviceplan Group Rus",
     "office": "MediaPlus Group"
   },
   {
     "id": 120,
     "text": "Mediaplus",
     "link": "https://adindex.ru/catalogue/digital/web_design/282039.phtml",
     "group": 2,
     "world": "Serviceplan Group",
     "russian": "Serviceplan Group Rus",
     "office": "MediaPlus Group"
   },
   {
     "id": 121,
     "text": "New Channel",
     "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/77303.phtml",
     "group": 2,
     "world": "Serviceplan Group",
     "russian": "Serviceplan Group Rus",
     "office": "MediaPlus Group"
   },
   {
     "id": 122,
     "text": "ТВКОМ",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/81931.phtml",
     "group": 2,
     "world": "Serviceplan Group",
     "russian": "Serviceplan Group Rus",
     "office": "MediaPlus Group"
   },
   {
     "id": 123,
     "text": "Louder",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/event/77008.phtml",
     "group": 3,
     "world": "Serviceplan Group",
     "russian": "Serviceplan Group Rus",
     "office": ""
   },
   {
     "id": 124,
     "text": "Plan.net",
     "link": "https://adindex.ru/catalogue/digital/web_design/278079.phtml",
     "group": 4,
     "world": "Serviceplan Group",
     "russian": "Serviceplan Group Rus",
     "office": ""
   },
   {
     "id": 125,
     "text": "Serviceplan Russia",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/104045.phtml",
     "group": 1,
     "world": "Serviceplan Group",
     "russian": "Serviceplan Group Rus",
     "office": ""
   },
   {
     "id": 126,
     "text": "Agency Assessments International",
     "link": "https://adindex.ru/catalogue/researches/134227/74774.phtml",
     "group": 3,
     "world": "Agency Assessments International",
     "russian": "",
     "office": ""
   },
   {
     "id": 127,
     "text": "Cheil Russia",
     "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/95659.phtml",
     "group": 5,
     "world": "Cheil Worldwide",
     "russian": "",
     "office": ""
   },
   {
     "id": 128,
     "text": "PRT",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/pr/77559.phtml",
     "group": 4,
     "world": "Edelman",
     "russian": "",
     "office": ""
   },
   {
     "id": 129,
     "text": "CPAExchange",
     "link": "https://adindex.ru/catalogue/digital/86980/97864.phtml",
     "group": 4,
     "world": "",
     "russian": "iConText Group",
     "office": ""
   },
   {
     "id": 130,
     "text": "iConText",
     "link": "https://adindex.ru/catalogue/digital/digital_creative/282041.phtml",
     "group": 4,
     "world": "",
     "russian": "iConText Group",
     "office": ""
   },
   {
     "id": 131,
     "text": "iSEO",
     "link": "https://adindex.ru/catalogue/digital/seo/96320.phtml",
     "group": 4,
     "world": "",
     "russian": "iConText Group",
     "office": ""
   },
   {
     "id": 132,
     "text": "Sociorama",
     "link": "https://adindex.ru/catalogue/digital/social_media/173452.phtml",
     "group": 4,
     "world": "",
     "russian": "iConText Group",
     "office": ""
   },
   {
     "id": 133,
     "text": "Zen Mobile Agency",
     "link": "https://adindex.ru/catalogue/reclama_services/group_of_companies/271920.phtml",
     "group": 4,
     "world": "",
     "russian": "iConText Group",
     "office": ""
   },
   {
     "id": 134,
     "text": "Registratura.ru",
     "link": "https://adindex.ru/catalogue/digital/social_media/90977.phtml",
     "group": 4,
     "world": "",
     "russian": "iConText Group",
     "office": ""
   },
   {
     "id": 135,
     "text": "Aviator",
     "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/75831.phtml",
     "group": 1,
     "world": "",
     "russian": "Rain Group",
     "office": ""
   },
   {
     "id": 136,
     "text": "i-Guru",
     "link": "https://adindex.ru/catalogue/digital/fullservice/99885.phtml",
     "group": 4,
     "world": "",
     "russian": "Rain Group",
     "office": ""
   },
   {
     "id": 137,
     "text": "Prior",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/99561.phtml",
     "group": 5,
     "world": "",
     "russian": "Rain Group",
     "office": ""
   },
   {
     "id": 138,
     "text": "Media Expert",
     "link": "https://adindex.ru/catalogue/digital/media_selling/282042.phtml",
     "group": 2,
     "world": "",
     "russian": "Rain Group",
     "office": ""
   },
   {
     "id": 139,
     "text": "Art Union",
     "link": "https://adindex.ru/catalogue/digital/media_selling/282043.phtml",
     "group": 1,
     "world": "",
     "russian": "Strong",
     "office": ""
   },
   {
     "id": 140,
     "text": "i-Brand",
     "link": "https://adindex.ru/catalogue/digital/context/76685.phtml",
     "group": 4,
     "world": "",
     "russian": "Strong",
     "office": ""
   },
   {
     "id": 141,
     "text": "NewIdeas",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/77321.phtml",
     "group": 3,
     "world": "",
     "russian": "Strong",
     "office": ""
   },
   {
     "id": 142,
     "text": "Strong",
     "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/73634.phtml",
     "group": 5,
     "world": "",
     "russian": "Strong",
     "office": ""
   },
   {
     "id": 143,
     "text": "International Media Solutions",
     "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/110436.phtml",
     "group": 2,
     "world": "",
     "russian": "MTG",
     "office": ""
   },
   {
     "id": 144,
     "text": "Main Target Group",
     "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/113537.phtml",
     "group": 5,
     "world": "",
     "russian": "MTG",
     "office": ""
   },
   {
     "id": 145,
     "text": "Интерсотрудничество",
     "link": "https://adindex.ru/catalogue/digital/fullservice/282044.phtml",
     "group": 3,
     "world": "",
     "russian": "MTG",
     "office": ""
   },
  {
    "id": 146,
    "text": "MultiTEC",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/94777.phtml",
    "group": 2,
    "world": "",
    "russian": "NMi Group",
    "office": ""
  },
  {
    "id": 147,
    "text": "NMi Digital",
    "link": "https://adindex.ru/catalogue/digital/102586/282045.phtml",
    "group": 4,
    "world": "",
    "russian": "NMi Group",
    "office": ""
  },
  {
    "id": 148,
    "text": "NM Science",
    "link": "https://adindex.ru/catalogue/digital/282046.phtml",
    "group": 2,
    "world": "",
    "russian": "NMi Group",
    "office": ""
  },
  {
    "id": 149,
    "text": "РРА",
    "link": "https://adindex.ru/catalogue/digital/digital_creative/282047.phtml",
    "group": 2,
    "world": "",
    "russian": "NMi Group",
    "office": ""
  },
  {
    "id": 150,
    "text": "Happ. Fabric",
    "link": "https://adindex.ru/catalogue/media/media_holdings/282048.phtml",
    "group": 3,
    "world": "",
    "russian": "INO Group",
    "office": ""
  },
  {
    "id": 151,
    "text": "INO Group",
    "link": "https://adindex.ru/catalogue/reclama_services/137296.phtml",
    "group": 3,
    "world": "",
    "russian": "INO Group",
    "office": ""
  },
  {
    "id": 152,
    "text": "Ruslo Branding & Advertising",
    "link": "https://adindex.ru/catalogue/media/radio/282049.phtml",
    "group": 1,
    "world": "",
    "russian": "INO Group",
    "office": ""
  },
  {
    "id": 153,
    "text": "Daromania",
    "link": "https://adindex.ru/catalogue/digital/mobile_marketing/282050.phtml",
    "group": 3,
    "world": "",
    "russian": "SA Media Group",
    "office": ""
  },
  {
    "id": 154,
    "text": "Ruport",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/77908.phtml",
    "group": 1,
    "world": "",
    "russian": "SA Media Group",
    "office": ""
  },
  {
    "id": 155,
    "text": "SA Digital",
    "link": "https://adindex.ru/catalogue/digital/context/278076.phtml",
    "group": 4,
    "world": "",
    "russian": "SA Media Group",
    "office": ""
  },
  {
    "id": 156,
    "text": "Smart View",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/78024.phtml",
    "group": 5,
    "world": "",
    "russian": "SA Media Group",
    "office": ""
  },
  {
    "id": 157,
    "text": "Deltaclick",
    "link": "https://adindex.ru/catalogue/digital/fullservice/270246.phtml",
    "group": 4,
    "world": "",
    "russian": "AG Deltaplan",
    "office": ""
  },
  {
    "id": 158,
    "text": "Deltaplan",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/73651.phtml",
    "group": 5,
    "world": "",
    "russian": "AG Deltaplan",
    "office": ""
  },
  {
    "id": 159,
    "text": "DeltaPrint",
    "link": "https://adindex.ru/catalogue/digital/digital_creative/282051.phtml",
    "group": 3,
    "world": "",
    "russian": "AG Deltaplan",
    "office": ""
  },
  {
    "id": 160,
    "text": "Fenomen",
    "link": "https://adindex.ru/catalogue/digital/fullservice/282052.phtml",
    "group": 3,
    "world": "",
    "russian": "AG Deltaplan",
    "office": ""
  },
  {
    "id": 161,
    "text": "Hoot Production",
    "link": "https://adindex.ru/catalogue/media/media_holdings/282053.phtml",
    "group": 3,
    "world": "",
    "russian": "AG Deltaplan",
    "office": ""
  },
  {
    "id": 162,
    "text": "Smelo",
    "link": "https://adindex.ru/catalogue/digital/fullservice/282054.phtml",
    "group": 3,
    "world": "",
    "russian": "AG Deltaplan",
    "office": ""
  },
  {
    "id": 163,
    "text": "Soda",
    "link": "https://adindex.ru/catalogue/digital/media_selling/282055.phtml",
    "group": 1,
    "world": "",
    "russian": "AG Deltaplan",
    "office": ""
  },
  {
    "id": 164,
    "text": "Wow",
    "link": "https://adindex.ru/catalogue/digital/web_design/97978.phtml",
    "group": 4,
    "world": "",
    "russian": "AG Deltaplan",
    "office": ""
  },
  {
    "id": 165,
    "text": "ACG",
    "link": "https://adindex.ru/catalogue/reclama_services/group_of_companies/73594.phtml",
    "group": 5,
    "world": "",
    "russian": "ACG",
    "office": ""
  },
  {
    "id": 166,
    "text": "ACG City",
    "link": "https://adindex.ru/catalogue/digital/fullservice/282056.phtml",
    "group": 5,
    "world": "",
    "russian": "ACG",
    "office": ""
  },
  {
    "id": 167,
    "text": "Catzwolf Digital",
    "link": "https://adindex.ru/catalogue/digital/fullservice/76059.phtml",
    "group": 4,
    "world": "",
    "russian": "Catzwolf Group",
    "office": ""
  },
  {
    "id": 168,
    "text": "Pravda.Production",
    "link": "https://adindex.ru/catalogue/digital/media_selling/282057.phtml",
    "group": 3,
    "world": "",
    "russian": "Catzwolf Group",
    "office": ""
  },
  {
    "id": 169,
    "text": "Artсom",
    "link": "https://adindex.ru/catalogue/digital/social_media/280483.phtml",
    "group": 5,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 170,
    "text": "Made",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/77035.phtml",
    "group": 5,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 171,
    "text": "Аудио Арт",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/280485.phtml",
    "group": 5,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 172,
    "text": "Восход",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/73955.phtml",
    "group": 5,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 173,
    "text": "Росст",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/101527.phtml",
    "group": 5,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 174,
    "text": "Adventum",
    "link": "https://adindex.ru/catalogue/digital/fullservice/89302.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 175,
    "text": "Arrow Media",
    "link": "https://adindex.ru/catalogue/digital/fullservice/275200.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 176,
    "text": "Artics Internet Solutions",
    "link": "https://adindex.ru/catalogue/digital/mobile_marketing/274880.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 177,
    "text": "Artox Media",
    "link": "https://adindex.ru/catalogue/digital/fullservice/90726.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 178,
    "text": "Deasign",
    "link": "https://adindex.ru/catalogue/digital/digital_creative/174285.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 179,
    "text": "Didenok",
    "link": "https://adindex.ru/catalogue/digital/social_media/278208.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 180,
    "text": "Digital Geeks",
    "link": "https://adindex.ru/catalogue/digital/seo/275204.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 181,
    "text": "Digital Milestone",
    "link": "https://adindex.ru/catalogue/digital/social_media/133055.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 182,
    "text": "Dot",
    "link": "https://adindex.ru/catalogue/digital/digital_creative/81186.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 183,
    "text": "Dr. Jung",
    "link": "https://adindex.ru/catalogue/digital/digital_creative/110417.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 184,
    "text": "Feedstars",
    "link": "https://adindex.ru/catalogue/foundation/influence/278207.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 185,
    "text": "Fistashki",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/pr/88823.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 186,
    "text": "Go Mobile",
    "link": "https://adindex.ru/catalogue/digital/mobile_marketing/136379.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 187,
    "text": "Gold Fish",
    "link": "https://adindex.ru/catalogue/131845/nativead/278068.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 188,
    "text": "Hate Agency",
    "link": "https://adindex.ru/catalogue/foundation/influence/278206.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 189,
    "text": "i.Com",
    "link": "https://adindex.ru/catalogue/digital/175470.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 190,
    "text": "i-Media",
    "link": "https://adindex.ru/catalogue/digital/context/278075.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 191,
    "text": "Ingate",
    "link": "https://adindex.ru/catalogue/digital/fullservice/125508.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 192,
    "text": "Mgcom",
    "link": "https://adindex.ru/catalogue/digital/context/77188.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 193,
    "text": "Medianation",
    "link": "https://adindex.ru/catalogue/digital/context/85230.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 194,
    "text": "Mediapronet",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/88447.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 195,
    "text": "Millennium-M",
    "link": "https://adindex.ru/catalogue/digital/fullservice/173759.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 196,
    "text": "Mobileup",
    "link": "https://adindex.ru/catalogue/digital/98880/132340.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 197,
    "text": "Mobio Agency",
    "link": "https://adindex.ru/catalogue/digital/mobile_marketing/278070.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 198,
    "text": "Molinos",
    "link": "https://adindex.ru/catalogue/digital/web_design/77230.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 199,
    "text": "Mosaic",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/74623.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 200,
    "text": "Nectarin",
    "link": "https://adindex.ru/catalogue/digital/fullservice/84318.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 201,
    "text": "Nimax",
    "link": "https://adindex.ru/catalogue/digital/web_design/84179.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 202,
    "text": "Positive Media",
    "link": "https://adindex.ru/catalogue/digital/fullservice/77540.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 203,
    "text": "Pro-Vision",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/pr/77637.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 204,
    "text": "R:TA",
    "link": "https://adindex.ru/catalogue/digital/context/278072.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 205,
    "text": "Realweb",
    "link": "https://adindex.ru/catalogue/digital/context/77831.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 206,
    "text": "Red Digital",
    "link": "https://adindex.ru/catalogue/digital/fullservice/280409.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 207,
    "text": "Rocket10",
    "link": "https://adindex.ru/catalogue/digital/mobile_marketing/166863.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 208,
    "text": "Scanners",
    "link": "https://adindex.ru/catalogue/digital/102586/170340.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 209,
    "text": "Sorry,Guys.Media",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/pr/278073.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 210,
    "text": "Sova Digital",
    "link": "https://adindex.ru/catalogue/digital/fullservice/167800.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 211,
    "text": "Tandem Group",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/112544.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 212,
    "text": "Techart",
    "link": "https://adindex.ru/catalogue/digital/web_design/278074.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 213,
    "text": "Vein Technologies",
    "link": "https://adindex.ru/catalogue/digital/social_media/274065.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 214,
    "text": "Wildjam",
    "link": "https://adindex.ru/catalogue/foundation/influence/278209.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  /*{
    "id": 215,
    "text": "Zen Mobile",
    "link": "https://adindex.ru/catalogue/reclama_services/group_of_companies/271920.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },*/
  {
    "id": 216,
    "text": "Zorka.Mobi",
    "link": "https://adindex.ru/catalogue/digital/media_selling/156798.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 217,
    "text": "Ашманов и Партнеры",
    "link": "https://adindex.ru/catalogue/digital/seo/79048.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 218,
    "text": "Блондинка.ру",
    "link": "https://adindex.ru/catalogue/digital/context/105227.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 219,
    "text": "Двигус",
    "link": "https://adindex.ru/catalogue/digital/seo/111794.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 220,
    "text": "ИВА-digital",
    "link": "https://adindex.ru/catalogue/digital/fullservice/157909.phtml",
    "group": 4,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 221,
    "text": "СМИ2",
    "link": "https://adindex.ru/catalogue/digital/seo/98148.phtml",
    "group": 5,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 222,
    "text": "Be Creative Agency",
    "link": "https://adindex.ru/catalogue/digital/digital_creative/278078.phtml",
    "group": 1,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 223,
    "text": "Depot WPF",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/branding/110373.phtml",
    "group": 1,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 224,
    "text": "Extract Communications",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/100533.phtml",
    "group": 1,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 225,
    "text": "Friends Moscow",
    "link": "https://adindex.ru/catalogue/digital/digital_creative/105219.phtml",
    "group": 1,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 226,
    "text": "Good Moscow",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/122111.phtml",
    "group": 1,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 227,
    "text": "Great",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/76624.phtml",
    "group": 1,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 228,
    "text": "Slava",
    "link": "https://adindex.ru/catalogue/digital/digital_creative/97953.phtml",
    "group": 1,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 229,
    "text": "CVG",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/170059.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 230,
    "text": "Granat Сommunications",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/creative/120753.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 231,
    "text": "LBL",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/76936.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 232,
    "text": "Lince OS",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/280417.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 233,
    "text": "Magma",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/80284.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 234,
    "text": "Media Impact",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/73759.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 235,
    "text": "Media108",
    "link": "https://adindex.ru/catalogue/digital/171532.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 236,
    "text": "Medianet",
    "link": "https://adindex.ru/catalogue/media/media_holdings/122115.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 237,
    "text": "Mediaselection",
    "link": "https://adindex.ru/catalogue/reclama_services/agencies/media/73763.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },

  {
    "id": 239,
    "text": "Simple Sport",
    "link": "https://adindex.ru/catalogue/digital/social_media/280418.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 240,
    "text": "PPL-Media",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/273919.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 241,
    "text": "Skytec",
    "link": "https://adindex.ru/catalogue/digital/media_selling/280415.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 242,
    "text": "Smartmedia",
    "link": "https://adindex.ru/catalogue/digital/media_selling/270993.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 243,
    "text": "Stargate Media Group",
    "link": "https://adindex.ru/catalogue/reclama_services/group_of_companies/83652.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 244,
    "text": "Total View",
    "link": "https://adindex.ru/catalogue/reclama_services/78214.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 245,
    "text": "Union Media Service",
    "link": "https://adindex.ru/catalogue/digital/media_selling/280420.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 246,
    "text": "Европа Адвертайзинг",
    "link": "https://adindex.ru/catalogue/media/outdoor_advertising/280421.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 247,
    "text": "Информ Экспресс",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/79896.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
  {
    "id": 248,
    "text": "Лидер Медиа",
    "link": "https://adindex.ru/catalogue/reclama_services/full_cycle/80206.phtml",
    "group": 2,
    "world": "",
    "russian": "",
    "office": ""
  },
];

function search(curStr) {
  let resultStr = '';
  let world = '';
  let office = '';
  let filters = '';

  $('.js-filter.active').each(function () {
    filters += $(this).attr('data-filter');
  });

  if (curStr.length > 0) {
    advertising.forEach(function (item, index) {
      if (item.text.toLowerCase().indexOf(curStr.toLowerCase()) > -1 && filters.indexOf(item.group) > -1) {

        world = '';
        office = '';

        if (item.world.length > 0) {
          world = '<span class="search-result__world">' + item.world + '</span>';
        }
        if (item.office.length > 0) {
          office = '<span class="search-result__office">' + item.office + '</span>';
        } else {
          if (item.russian.length > 0) {
            office = '<span class="search-result__office">' + item.russian + '</span>';
          }
        }
        resultStr += '<div class="search-results__str">' +
          '<a href="#" class="search-result js-result js-result" data-filter-id="' + item.id + '">' +
          '<span class="search-result__icon" data-filter="' + item.group + '"><img class="svg" src="assets/i/sprite/circle.svg" alt=""></span>' +
          '<span class="search-result__text">' +
          '<span class="search-result__title">' + item.text + '</span>' +
          '<span class="search-result__bottom">' +  world + office + '</span>'+
          '</span>' +
          '</a>' +
          '</div>';
      }
    });
  }
  if ($(window).width() > 767) {
    if (resultStr.length > 0) {
      $('.search-results').addClass('active');
      $('.search-results__wrap').html(resultStr);
    } else {
      $('.search-results').removeClass('active');
      $('.search-results__wrap').html('');
    }
  } else {
    if (resultStr.length > 0) {
      $('.mobile-search__results').html(resultStr);
    } else {
      $('.mobile-search__results').html('');
    }
  }
}

let funcInit = function(){
  const zoom = new Zoom().render();
}
document.addEventListener('DOMContentLoaded', funcInit);

$(document).ready(() => {

  $('.js-partners-close').on('click', function () {
    $('.map-partners').removeClass('active');
    $('.map-controls').removeClass('not-bottom');
  });
  $('.js-filter-clear').on('click', function () {
    $('.js-filter').removeClass('active');
    $('.js-mobile-filter').removeClass('active');
    $( "[class^='st']" ).removeClass('active');
    $( ".map-text" ).removeClass('active');
    $( "circle[class^='filter']" ).addClass('hide');

    if ($('#search').val().length > 0) {
      search($('#search').val());
    }
  });
  $('.js-filter').on('click', function () {
    const dataIndex = $(this).attr('data-filter');
    if ($(this).hasClass('active') && $('.js-filter').length === $('.js-filter.active').length) {
      $('.js-filter').removeClass('active');
      $('.js-mobile-filter').removeClass('active');

      $(this).addClass('active');
      $( "[class^='st']" ).removeClass('active');
      $( ".map-text" ).removeClass('active');
      $( "circle[class^='filter']" ).addClass('hide');

      $('.st' + dataIndex).addClass('active');
      $('.mt' + dataIndex).addClass('active');
      $('.filter' + dataIndex).removeClass('hide');
      $('.js-mobile-filter[data-filter="' + dataIndex + '"]').addClass('active');

      if ($('#search').val().length > 0) {
        search($('#search').val());
      }

      return false;
    }
    if ($(this).hasClass('active') && $('.js-filter.active').length === 1) {
      $('.js-filter').addClass('active');
      $('.js-mobile-filter').addClass('active');
      $( "[class^='st']" ).addClass('active');
      $( ".map-text" ).addClass('active');
      $( "circle[class^='filter']" ).removeClass('hide');
      if ($('#search').val().length > 0) {
        search($('#search').val());
      }
      return false;
    }

    $(this).toggleClass('active');
    $('.st' + dataIndex).toggleClass('active');
    $('.mt' + dataIndex).toggleClass('active');
    $('.filter' + dataIndex).toggleClass('hide');
    $('.js-mobile-filter[data-filter="' + dataIndex + '"]').toggleClass('active');

    if ($('#search').val().length > 0) {
      search($('#search').val());
    }
  });
  $('.js-mobile-filter').on('click', function () {
    const dataIndex = $(this).attr('data-filter');
    if ($(this).hasClass('active') && $('.js-mobile-filter').length === $('.js-mobile-filter.active').length) {
      $('.js-filter').removeClass('active');
      $('.js-mobile-filter').removeClass('active');

      $(this).addClass('active');
      $( "[class^='st']" ).removeClass('active');
      $( ".map-text" ).removeClass('active');
      $( "circle[class^='filter']" ).addClass('hide');

      $('.st' + dataIndex).addClass('active');
      $('.mt' + dataIndex).addClass('active');
      $('.filter' + dataIndex).removeClass('hide');
      $('.js-filter[data-filter="' + dataIndex + '"]').addClass('active');

      if ($('#search').val().length > 0) {
        search($('#search').val());
      }

      return false;
    }
    if ($(this).hasClass('active') && $('.js-filter.active').length === 1) {
      $('.js-filter').addClass('active');
      $('.js-mobile-filter').addClass('active');
      $( "[class^='st']" ).addClass('active');
      $( ".map-text" ).addClass('active');
      $( "circle[class^='filter']" ).removeClass('hide');
      if ($('#search').val().length > 0) {
        search($('#search').val());
      }
      return false;
    }

    $(this).toggleClass('active');
    $('.st' + dataIndex).toggleClass('active');
    $('.mt' + dataIndex).toggleClass('active');
    $('.filter' + dataIndex).toggleClass('hide');
    $('.js-filter[data-filter="' + dataIndex + '"]').toggleClass('active');

    if ($('#search').val().length > 0) {
      search($('#search').val());
    }
  });
  $('.js-popup-close').on('click', function () {
    $('.map-popup-bg').removeClass('active');
    $('.map-popup').removeClass('isOpen');
  });
  $('.js-info').on('click', function () {
    $('.map-popup-bg').addClass('active');
    $('.map-popup').addClass('isOpen');
  });

  $('.js-search-open').on('click', function () {
    $(this).removeClass('active');
    $('.map-search').addClass('active');
    $('#search').focus();
  });
  $('.js-search-close').on('click', function () {
    $('.map-search').removeClass('active');
    $('.search-results').removeClass('active');
    $('.js-search-open').addClass('active');
    $('#search').val('');
    $('.search-results__wrap').html('');
  });

  /*$('.map-text').on('click', function () {
    const curId = $(this).attr('data-id');
    let href;
    advertising.forEach(function (item, index) {
      if (parseInt(item.id) === parseInt(curId)) {
        href = item.link;
        //window.location.href = href;
        window.open(href);
      }
    });
  }); */
  $('.map-link').on('click', function () {
    const curId = $(this).attr('data-id');
    let href;
    advertising.forEach(function (item, index) {
      if (parseInt(item.id) === parseInt(curId)) {
        href = item.link;
        //window.location.href = href;
        window.open(href);
      }
    });
  });

  $('#search').on('input', function () {
    let curStr = $(this).val();
    search(curStr);
  });
  $('#searchMobile').on('input', function () {
    let curStr = $(this).val();
    search(curStr);
  });
  $('.js-mobile-search-open').on('click', function () {
    //$('#searchMobile').focus();
  });
  $(document).on('touchstart', '.js-mobile-search-open', function(){
    //$('#searchMobile').focus();
  });

  $('.dropdown--search').on('shown.bs.dropdown', function () {
    $('#searchMobile').focus();
  })

  $('.map-header').on('dblclick', function (e) {
    e.preventDefault();
  });

  document.getElementsByClassName("map-header")[0].addEventListener("touchstart", tapHandler);
  document.getElementsByClassName("map-controls")[0].addEventListener("touchstart", tapHandler);
  document.getElementsByClassName("map-partners")[0].addEventListener("touchstart", tapHandler);

  let tapedTwice = false;

  function tapHandler(event) {
    if(!tapedTwice) {
      tapedTwice = true;
      setTimeout( function() { tapedTwice = false; }, 300 );
      return false;
    }
    event.preventDefault();
  }

});

$(document).on('mouseup', function (e) {

  const results = $('.search-results');
  const filter = $('.map-header__filters');
  const form = $('.map-search');
  const open = $('.js-search-open');

  if (results.has(e.target).length === 0 && filter.has(e.target).length === 0 && form.has(e.target).length === 0 && open.has(e.target).length === 0) {
    $('.map-search').removeClass('active');
    $('.search-results').removeClass('active');
    setTimeout(function () {
      $('.js-search-open').addClass('active');
      $('#search').val('');
      $('.search-results__wrap').html('');
    },310);
  }
});
